import auth from '@/lib/auth/oAuth'

auth.init()

//挂载 App
import(
  /* webpackChunkName: "index-async" */
  './index.async'
)
